export class IDataAccess{
  doc: string;
  name: string;
  surname: string;
  cellphone: number;
  email: string;
  residenceCountry: number  = 0;
  residenceDepartment: number = 0;
  residenceCity: number = 0;
  campus: number;
  school: number;
  program: number;
  isGraduated: boolean = false;

  constructor(def:any){
    this.doc = def.doc || "";
    this.name = def.name || "";
    this.surname = def.surname || "";
    this.cellphone = def.cellphone || 0;
    this.email = def.email || "";
    this.residenceCountry = def.residenceCountry || "";
    this.residenceDepartment = def.residenceDepartment;
    this.residenceCity = def.residenceCity;
    this.campus = def.campus;
    this.school = def.school;
    this.program = def.program;
    this.isGraduated = def.isGraduated;
  }

}